const stripeActionTypes ={
    CREATE_CUSTOMER: "CREATE CUSTOMER",
    ACTIVATE_COMMITTEE: "ACTIVATE COMMITTEE",
    GET_COMMITTEE_PRODUCT: "GET COMMITTEE PRODUCT",
    CREATE_CHECKOUT_SESSION: 'CREATE_CHECKOUT_SESSION',
}


export default stripeActionTypes